import {connect} from 'react-redux';
import {Component} from 'react';

import {authenticate} from '-/util/authenticate';
import UIService from '-/services/UIService';
import Button from '-/components/general/Button';
class BypassAuthButton extends Component {
    render() {
        const { authenticate, authType, authInfo, buttonText } = this.props;
        let formattedAuthInfo = '';

        switch(authType) {
            case 'dob':
                formattedAuthInfo = new Date(authInfo).setUTCHours(0);
                break;
            default:
                formattedAuthInfo = authInfo;
        }

        return (
            <Button
                width={90}
                tag="a"
                href="#"
                title={buttonText}
                role="button"
                onClick={e => {
                    e.preventDefault();
                    UIService.stepCompleted('hero');
                    authenticate(authType, formattedAuthInfo);
                }}>
                {buttonText}
            </Button>
        );
    }
}

export default connect(null, { authenticate })(BypassAuthButton);
